import { Currency as APICurrencyAmount } from 'APIs/fragments';
import numeral from 'numeral';
export type Currency = 'AUD' | 'NZD' | 'ZAR';

export const CountryCurrency: { [country: string]: Currency } = {
  AU: 'AUD',
  NZ: 'NZD',
  ZA: 'ZAR',
};

export const formatCurrency = (amount: number, currency: Currency): string =>
  new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
  }).format(amount);

export const formatAmount = (amount: number, options?: { useGrouping?: boolean }): string =>
  new Intl.NumberFormat(navigator.language, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: options?.useGrouping ?? true,
  }).format(amount);

export const toCurrency = (amount: Nullable<number>, currency: Currency): string =>
  formatCurrency(
    numeral(amount ?? 0)
      .divide(100)
      .value() ?? 0,
    currency,
  );

export const fromCurrency = (amount: string): number =>
  Number(
    numeral(amount || '0')
      .multiply(100)
      .format('0'),
  );

export const divideBy100 = (amount: Nullable<number>): number =>
  numeral(amount ?? 0)
    .divide(100)
    .value() ?? 0;

export const timesBy100 = (amount: string): number =>
  numeral(amount || '0')
    .multiply(100)
    .value() ?? 0;

export const formatAPICurrencyAmount = (amount: APICurrencyAmount, options?: { suffixCurrencyCode: boolean }): string =>
  `${new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: amount.currency,
  }).format(divideBy100(amount.minorCurrencyUnits))}${options?.suffixCurrencyCode ? ' ' + amount.currency : ''}`;

export const minorCurrencyUnits = (amount: number): number => Math.floor(numeral(amount).multiply(100).value() ?? 0);
